import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ selector = "#main-content" }) {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // 1) попытка скролла внутреннего контейнера (если есть)
    try {
      const container = document.querySelector(selector);
      if (container) {
        // instant jump — без анимации
        container.scrollTop = 0;
      }
    } catch (e) {
      // ignore
    }

    // 2) на всякий случай скроллим window тоже
    try {
      // using instant behavior to avoid visible smooth animation from bottom
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      // также для совместимости:
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    } catch (e) {}
  }, [pathname, selector]);

  return null;
}